import { Component, OnInit, EventEmitter, Input, AfterContentChecked } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Global } from 'src/app/core/resources/global';
import { ManualCreationCargoService } from 'src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service';
import { Utils } from 'src/app/core/resources/utils';
import { Router } from '@angular/router';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { CargoResources } from '../../resources/cargo';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateFormatPipe } from 'src/app/core/pipe/dateFormat.pipe';

import { DownloadService } from './download.service';
import { importExpr } from '@angular/compiler/src/output/output_ast';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CargoFeature } from 'src/app/core/interfaces/cargoFeature';
import { AddressCargo } from 'src/app/core/interfaces/addressCargo';
import { GoogleService } from 'src/app/core/services/google.service';
import { Patterns } from 'src/app/core/resources/patterns';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { Fmt } from 'src/app/core/messages/fmt';
import { DateManager } from 'src/app/core/managers/date.manager';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { SettingId } from 'src/app/core/interfaces/saas-config';

@Component({
  selector: 'app-download-freight',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss'],
  providers: [AuthService, Global]
})

export class DownloadComponent implements OnInit {
  prueba2: any;
  timeDownload = [];
  times: any;
  permission = Permission;
  stimated_time: any;
  timeList: Array<{ value: string, title: string }> = [];
  hourList: Array<{ value: number, title: string }> = [];
  minuteList: Array<{ value: number, title: string }> = [];
  public guide: string = "";
  formDownload = this.fb.group({
    number: new FormControl('', [Validators.minLength(9), Validators.required, Validators.pattern("^[0-9]*$")]),
    email: new FormControl('', [Validators.email, Validators.required, Validators.pattern(this.patterns.EMAIL.source), Validators.maxLength(100)])
  });
  minLengthCellphone: number = 9;
  maxLengthCellphone: number = 12;
  minTimePact: number = 1;
  hourOptionsByAddress: Array<Array<Array<{ value: number, title: string }>>> = [];
  minuteOptionsByAddress: Array<Array<Array<{ value: number, title: string }>>> = [];
  constructor(
    public DownloadService: DownloadService,
    public patterns: Patterns,
    private permissionRole: PermissionRole,
    public manualCreationCargoService: ManualCreationCargoService,
    public utils: Utils,
    private router: Router,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public authService: AuthService,
    private fb: FormBuilder,
    private snackBarService: SnackBarService,
    private googleService: GoogleService,
    private cargoManager: CargoManager
  ) {
    this.timeList = this.utils.getListTime();
    this.hourList = this.utils.getListHour();
    this.minuteList = this.utils.getListMinute();
  }

  ngOnInit() {
    this.setValidatorsDownload();
    this.buildTimePactOptions();
  }



  get destinations() {
    return this.manualCreationCargoService.cargoForm.controls.cargoFeature['controls'].uploadDownload.controls.destination.controls;
  }

  private getAddressGroupActive(index: number, iDestination: number): AbstractControl {
    let ctrl: AbstractControl;
    if (index >= 0) {
      ctrl = this.manualCreationCargoService.cargoForm.get(`cargoFeature.uploadDownload.destination.${iDestination}.addresses.${index}`);
    }
    return ctrl;
  }

  setValidatorsDownload() {
    for (let control of this.manualCreationCargoService.formDestinations.controls) {
      let arrayAddresses = control.get('addresses') as FormArray;
      for (let addressControl of arrayAddresses.controls) {
        if (this.utils.isTeclogiUserOrClient) {
          if (this.utils.isEmptyTeclogiTimePact(addressControl.get('timePact').value, addressControl.get('minutePact').value)) {
            const def = this.utils.getTeclogiDefaultTimePact();
            addressControl.get('timePact').setValue(def.hours);
            addressControl.get('minutePact').setValue(def.minutes);
          }
        } else {
          addressControl.get('timePact').setValidators(Validators.min(this.minTimePact));
          !addressControl.get('timePact').value && addressControl.get('timePact').setValue(this.minTimePact);
        }
        addressControl.get('time').setValidators(Validators.required);
        addressControl.get('email').setValidators([Validators.pattern(this.patterns.EMAIL.source), Validators.maxLength(100)]);
        addressControl.get('cellphone').setValidators([Validators.minLength(this.minLengthCellphone), Validators.maxLength(this.maxLengthCellphone), Validators.pattern(this.patterns.CELLPHONEANDLANDLINE.source)]);
      }
    }
  }

  /**
   * Precomputa las opciones de tiempo pactado por destino/dirección como referencias
   * estables, para no generar arreglos nuevos en cada ciclo de change detection desde
   * el template (causa del bucle infinito con mat-select).
   */
  private buildTimePactOptions() {
    this.hourOptionsByAddress = [];
    this.minuteOptionsByAddress = [];
    this.destinations.forEach((destination, iDestination) => {
      this.hourOptionsByAddress[iDestination] = [];
      this.minuteOptionsByAddress[iDestination] = [];
      const addresses = (destination.get('addresses') as FormArray).controls;
      addresses.forEach((address, index) => this.setTimePactOptions(iDestination, index, address));
    });
  }

  private setTimePactOptions(iDestination: number, index: number, address: AbstractControl) {
    if (!address) return;
    if (!this.hourOptionsByAddress[iDestination]) this.hourOptionsByAddress[iDestination] = [];
    if (!this.minuteOptionsByAddress[iDestination]) this.minuteOptionsByAddress[iDestination] = [];
    const hours = address.get('timePact').value;
    const minutes = address.get('minutePact').value;
    this.hourOptionsByAddress[iDestination][index] = this.utils.getTimePactHourList(this.utils.isTeclogiUserOrClient, this.hourList, hours);
    this.minuteOptionsByAddress[iDestination][index] = this.utils.getTimePactMinuteList(this.utils.isTeclogiUserOrClient, hours, this.minuteList, minutes);
  }

  setUpperCase($event, iDestination, index) {
    (this.getAddressGroupActive(index, iDestination) as FormGroup).get('email').setValue($event.srcElement.value.toLowerCase());
  }

  public onKeyUpGuideId($event: any, iDestination: number, index: number, indexGuideId: number): void {
    this.getAddressGroupActive(index, iDestination).get(`guidesId.${indexGuideId}.value`).setValue(
      $event.target.value
    );
  }

  getDestinationAddressGuidesRecipients(indexDestination: number, indexAddress: number): FormArray {
    return this.destinations[indexDestination].get('addresses').controls[indexAddress].get('guidesRecipients') as FormArray;
  }

  addGuidesRecipients(indexDestination: number, indexAddress: number) {
    try {
      this.getDestinationAddressGuidesRecipients(indexDestination, indexAddress).push(
        this.fb.group({
          name: '',
          phone: '',
          email: '',
          clientId: ''
        }));
    } catch (error) {
      this.snackBarService.openSnackBar('No fue posible agregar la guía', undefined, 'alert');
    }
  }

  removeGuidesRecipients(indexDestination: number, indexAddress: number, indexRecipient: number) {
    try {
      this.getDestinationAddressGuidesRecipients(indexDestination, indexAddress).removeAt(indexRecipient);
    } catch (error) {
      this.snackBarService.openSnackBar('No fue posible eliminar la guía', undefined, 'alert');
    }
  }

  public refreshFormCargo() {
    const cloneValue = this.utils.clone(this.manualCreationCargoService.cargoForm.value);
    this.manualCreationCargoService.refreshCargoForm(cloneValue);
    this.setValidatorsDownload();
    this.buildTimePactOptions();
  }

  findErrorOnDestinations() {
    let haveErrors = false;
    for (let [i, control] of this.manualCreationCargoService.formDestinations.controls.entries()) {
      let arrayAddresses = control.get('addresses') as FormArray;
      for (let [j, addressControl] of arrayAddresses.controls.entries()) {
        if (!haveErrors) {
          if (this.utils.errorMessagesCustomized(addressControl.get('time'), `hora de descargue del destino ${i + 1} de la dirección ${j + 1}`)) {
            haveErrors = true;
            break;
          }
          else if (this.utils.errorMessagesCustomized(addressControl.get('cellphone'), `celular del destino ${i + 1} de la dirección ${j + 1}`, this.minLengthCellphone, this.maxLengthCellphone)) {
            haveErrors = true;
            break;
          }
          else if (this.utils.errorMessagesCustomized(addressControl.get('email'), `correo del destino ${i + 1} de la dirección ${j + 1}`, null, 100)) {
            haveErrors = true;
            break;
          }
        } else break;
      }
      if (haveErrors) break;
    }
    return haveErrors;
  }

  async nextStep() {
    const isValidDates = await this.manualCreationCargoService.isValidAllDateTimeDowndload();
    if (!isValidDates) {
      this.snackBarService.openSnackBar(Fmt.string(FormMessages.TIME_INVALID2, 'descargue'), undefined, 'alert');
    } else if (!this.manualCreationCargoService.isValidDownloadAddressesAdditionalData() || this.manualCreationCargoService.formDestinations.invalid) {
      if (!this.findErrorOnDestinations()) this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT, undefined, 'error');
    } else if (!this.activeStimatedTimeAlert()) {
      this.manualCreationCargoService.showMessageWrongDuration();
    } else if (this.hasAdditionalCostsPermission) {
      this.manualCreationCargoService.getComponentActive().setId(3);
      this.manualCreationCargoService.getComponentActive().getStep().setId(3);
      this.router.navigate([this.manualCreationCargoService.steps.additionalService.url]);
    } else {
      this.manualCreationCargoService.getComponentActive().setId(4);
      this.manualCreationCargoService.getComponentActive().getStep().setId(1);
      this.router.navigate([this.manualCreationCargoService.steps.cargoValue.url]);
    }
  }

  activeStimatedTimeAlert() {
    const destinations = this.manualCreationCargoService.getCargoForm().get('cargoFeature.uploadDownload.destination').value;
    let valid = true;
    destinations.forEach((destination, indexDestination) => {
      destination.addresses.forEach((address, index) => {
        if (this.manualCreationCargoService.getEstimatedTimeDownload(indexDestination, index, address.time) !== false) valid = false;
      })
    });
    return valid;
  }

  async createCargo() {
    const isValidDates = await this.manualCreationCargoService.isValidAllDateTimeDowndload();
    if (!isValidDates) {
      this.snackBarService.openSnackBar(Fmt.string(FormMessages.DATE_INVALID2, 'descargue'), undefined, 'alert');
    }
    else if (!this.manualCreationCargoService.isValidAdditionalCosts()) {
      let index = -1
      if (this.manualCreationCargoService.formOriginadditionalCosts.value.length) {
        index = this.manualCreationCargoService.formOriginadditionalCosts.value.findIndex((addCost) => !addCost.cost && !addCost.rate);
      }
      this.snackBarService.openSnackBar(Fmt.string(FormMessages.MISSING_FIELD, index !== -1
        ? `tarifa o costo del servicio adicional ${index + 1}`
        : "tarifa o costo de algún servicio adicional"), undefined, 'alert');
    }
    else {
      this.spinner.show();
      this.manualCreationCargoService.processCargo()
        .then((data: Cargo[]) => {
          this.cargoManager.modalCargoCreation(data, `Tu solicitud ha sido creada exitosamente con los siguientes consecutivos`);
        })
        .catch((error) => {
          this.manualCreationCargoService.showResponseCreateCargo(
            'Ocurrió un error al crear la solicitud',
            (Array.isArray(error) ? error : undefined)
          );
        })
        .finally(() => {
          this.spinner.hide();
        });
    }
  }

  get addresses() {
    return (this.manualCreationCargoService.cargoForm.get('cargoFeature.uploadDownload.origin.addresses') as FormArray).controls;
  }

  get addressesDst() {
    return (this.manualCreationCargoService.cargoForm.get('cargoFeature.uploadDownload.destination') as FormArray).controls;
  }

  get hasAdditionalCostsPermission(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.additionalCosts
    )
  }


  convertupload() {
    this.times = this.DownloadService.convert24(this.addresses).toString();
  }

  private get cargoFeature(): CargoFeature {
    return this.manualCreationCargoService.cargoForm.value.cargoFeature;
  }

  private get dateLoad(): string {
    return this.manualCreationCargoService.cargoForm.value.dateLoad;
  }

  get hasManifest(): boolean {
    return !!this.manualCreationCargoService.cargoForm.value.ministry;
  }

  private getAddresses(): Array<AddressCargo> {
    const origins = this.utils.clone(this.cargoFeature.uploadDownload.origin);
    const destinations = this.utils.clone(this.cargoFeature.uploadDownload.destination);
    const allAddresses = [];
    for (const i in origins.addresses) {
      origins.addresses[i].date = this.dateLoad;
      allAddresses.push(origins.addresses[i]);
    }
    destinations.forEach((destination, index: number) => {
      destination.addresses.forEach((address: AddressCargo, i: number) => {
        address.date = destination.downloadDate;
        address.destinationId = index;
        address.id = i.toString();
        allAddresses.push(address);
      });
    });
    return allAddresses;
  }

  onSelectTime($event: MatSelectChange, key: string, iDestination: number, index: number) {
    this.getAddressGroupActive(index, iDestination).get(key).setValue($event.value);
    if (this.utils.isTeclogiUserOrClient && key === 'timePact') {
      const minuteCtrl = this.getAddressGroupActive(index, iDestination).get('minutePact');
      if (Number($event.value) === 1) minuteCtrl.setValue(0);
      else if (Number($event.value) === 0 && !(Number(minuteCtrl.value) > 0)) minuteCtrl.setValue(5);
    }
    if (key === 'timePact' || key === 'minutePact') this.setTimePactOptions(iDestination, index, this.getAddressGroupActive(index, iDestination));
    const addressControl = this.getAddressGroupActive(index, iDestination);
    const address: AddressCargo = addressControl.value;
    this.normalize(iDestination, index);
    this.manualCreationCargoService.estimatedTimes[iDestination][index] = false;
    //check next address if exists
    const addresses: AddressCargo[] = this.getAddresses();
    const currentIndex: number = addresses.findIndex(addressIn => addressIn.location.lat === address.location.lat && addressIn.location.lng === address.location.lng);
    if (currentIndex !== -1) {
      if (addresses && addresses[currentIndex + 1] && addresses[currentIndex + 1].time) {
        this.normalize(iDestination, index);
        this.manualCreationCargoService.estimatedTimes[iDestination][index] = false;
      }
    }
  }

  public normalize(iDestination, iAddress) {
    if (this.manualCreationCargoService.estimatedTimes[iDestination] === undefined) {
      this.manualCreationCargoService.estimatedTimes[iDestination] = {};
      if (this.manualCreationCargoService.estimatedTimes[iDestination][iAddress] === undefined)
        this.manualCreationCargoService.estimatedTimes[iDestination][iAddress] = false;
    }
  }

  public isValidAddress(i, iD) {
    return this.manualCreationCargoService.isValidAddressDateTimeLoad(i, iD);
  }
  public isValidToLast(i, iD) {
    return this.manualCreationCargoService.isValidAddressTimeDownloadToLast(i, iD);
  }
  public isValidToOrigin(i, iD) {
    return this.manualCreationCargoService.isValidFirstAddressTimeDownload(i, iD);
  }

  stepBack() {
    this.manualCreationCargoService.getComponentActive().setId(3);
    this.manualCreationCargoService.getComponentActive().getStep().setId(1);
    this.router.navigate([this.manualCreationCargoService.steps.upload.url]);
  }




  //GETTERS
  getPreviosAddTime(index: number, iDestination: number): string {
    const addressControl = this.getAddressGroupActive(index, iDestination);
    const address: AddressCargo = addressControl.value;
    let addresses: AddressCargo[] = this.getAddresses();
    let currentIndex: number = -1;
    if (addresses)
      currentIndex = addresses.findIndex(addressIn => addressIn.location.lat === address.location.lat && addressIn.location.lng === address.location.lng);
    if (currentIndex >= 0 && addresses && addresses.length && addresses[currentIndex] && addresses[currentIndex - 1]) return addresses[currentIndex - 1].time;
    return '';
  }
  trackByOptionValue(_index: number, option: { value: number, title: string }): number {
    return option.value;
  }
}
